import type { SelectItem } from '@/shared/ui/multiple-select/types'

export const GRADES: SelectItem[] = Array.from({ length: 12 }, (_, i) => ({
  title: i.toString(),
  value: i.toString(),
}))
